import { FC } from "react";
import EditTMMSvg from "../../public/icons/edit_tmm.svg";
import { IconProps, useAddMissingAntIconClass } from "../hooks/use-add-missing-ant-icon-class";

export const EditTMMIcon: FC<IconProps> = (iconProps) =>
  <span role="img" {...useAddMissingAntIconClass(iconProps)}><EditTMMSvg/></span>;
